import { create } from 'zustand';
import axios from 'axios';

const useThemeStore = create((set, get) => ({
  currentTheme: null,
  loading: false,
  
  // 获取当前激活的主题
  fetchCurrentTheme: async () => {
    set({ loading: true });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/admin/themes/active', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.data.success) {
        set({ currentTheme: response.data.theme });
        // 应用主题到CSS变量
        get().applyTheme(response.data.theme);
      }
    } catch (error) {
      console.error('获取主题失败:', error);
      // 使用默认主题
      const defaultTheme = {
        name: '默认主题',
        primary_color: '#3B82F6',
        secondary_color: '#1E40AF',
        background_color: '#F8FAFC',
        text_color: '#1F2937'
      };
      set({ currentTheme: defaultTheme });
      get().applyTheme(defaultTheme);
    } finally {
      set({ loading: false });
    }
  },
  
  // 应用主题到CSS变量
  applyTheme: (theme) => {
    if (!theme) return;
    
    const root = document.documentElement;
    root.style.setProperty('--primary-color', theme.primary_color);
    root.style.setProperty('--secondary-color', theme.secondary_color);
    root.style.setProperty('--background-color', theme.background_color);
    root.style.setProperty('--text-color', theme.text_color);
    
    // 更新页面背景色
    document.body.style.backgroundColor = theme.background_color;
    
    // 更新底部导航栏颜色
    const bottomNav = document.querySelector('.bottom-nav');
    if (bottomNav) {
      bottomNav.style.backgroundColor = theme.background_color;
    }
    
    // 更新激活状态颜色
    const style = document.createElement('style');
    style.textContent = `
      .bottom-nav .ant-tabs-tab-active {
        background-color: ${theme.primary_color}20 !important;
        color: ${theme.primary_color} !important;
      }
      .bottom-nav .ant-tabs-tab:hover {
        color: ${theme.primary_color} !important;
      }
      .bottom-nav .ant-tabs-ink-bar {
        background-color: ${theme.primary_color} !important;
      }
    `;
    
    // 移除之前的样式
    const existingStyle = document.getElementById('theme-style');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    style.id = 'theme-style';
    document.head.appendChild(style);
  },
  
  // 刷新主题
  refreshTheme: () => {
    get().fetchCurrentTheme();
  }
}));

export default useThemeStore;
